import { gql } from 'graphql-tag';

export const LISTING_FRAGMENT = gql`
    fragment LISTING on ListingData {
        listingId
        displayAddress
        category
        location {
            postalCode
            streetName
        }
        section
        branch {
            logoUrl
            name
        }
        featurePreview {
            iconId
            content
        }
        imagePreview {
            caption
            src
            responsiveImgList {
                src
                width
            }
        }
        listingUris {
            contact
            detail
        }
        pricing {
            label
        }
        tags {
            label
        }
        title
        transports {
            distanceInMiles
            poiType
            title
        }
        publicationStatus
        publishedOn
        numberOfImages
        statusSummary {
            label
        }
    }
`;
